<template>
    <el-row justify="center" align="middle" class="login-container">
      <el-col :xs="20" :sm="16" :md="10" :lg="8"> 
        <el-card class="login-card">
          <h2 class="text-center">Login</h2>
          <el-form :model="form" :rules="rules" ref="loginForm" label-width="100px">
            <el-form-item label="Username" prop="username">
              <el-input v-model="form.username" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="Password" prop="password">
              <el-input v-model="form.password" type="password" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item class="button-container">
              <el-button type="primary" @click="handleLogin" :loading="loading" size="large" class="full-width">Login</el-button>

           
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </template>
  
  <script setup>
  import { reactive, ref } from "vue";
  import { useRouter } from "vue-router";
  import { ElMessage } from "element-plus";
  import { useUserStore } from "@/stores/user";
  import axiosInstance from "@/api/axios"; // Axios 인스턴스 가져오기
  const isMobile = ref(window.innerWidth <= 768);

  
  // Vue Router와 Pinia 스토어 초기화
  const router = useRouter();
  const userStore = useUserStore();
  
  // 상태 및 폼 초기화
  const form = reactive({
    username: "",
    password: "",
  });
  
  const rules = {
    username: [{ required: true, message: "Please enter your username", trigger: "blur" }],
    password: [{ required: true, message: "Please enter your password", trigger: "blur" }],
  };
  
  const loginForm = ref(null);
  const loading = ref(false);
  
  // 로그인 처리
  const handleLogin = async () => {
    if (!loginForm.value) return;
  
    try {
      loading.value = true;

      // API 호출
      const response = await axiosInstance.post("/token/", {
        username: form.username,
        password: form.password,
      });
  
      // 토큰 저장
      localStorage.setItem("access_token", response.data.access);
      localStorage.setItem("refresh_token", response.data.refresh);
      console.log("LoginView: accessToken:=" ,response.data.access)
  


         //임시패스워드로로그인시 패스워드변경으로 강제이동 
      if(response.data.force_password_change){
       
        console.log(" push to changepassword")
       
         router.push('/changepassword')

      }else {
        console.log(" userStore.fetchUserProfile")

          // 사용자 프로필 정보 가져오기
          await userStore.fetchUserProfile();
        
          // 🔹 로그인 성공 후 푸시 구독 실행
          // 푸시 구독 안하도록 수정(2025.03.01)
          /*
          if ("Notification" in window && Notification.permission === "granted") {
            await userStore.subscribeToPush();
          } else {
            ElMessage.info("푸시 알림을 받으려면 알림 권한을 허용하세요.");
          }
            */
          isMobile.value = ref(window.innerWidth <= 768);
           console.log("isMobile=",isMobile.value)
             // ✅ 로그인 후 모바일이면 휴가 승인 화면으로 이동
      
                  ElMessage.success({ message: "로그인 성공!", offset: 70, duration: 2000 });
                  router.push("/dashboard"); // 대시보드로 이동
            

      }

    } catch (error) {
      console.log(error)
      ElMessage.error("Invalid username or password.");
    } finally {
      loading.value = false;
    }
  };



 
  </script>
  
  <style scoped>
  .login-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 60px - 50px); /* 헤더와 푸터를 제외한 높이 */
    padding: 20px;

  }
  
  .text-center {
    text-align: center;
  }
  .full-width {
    width: 100%;
  }

  .button-container {
  display: flex;
  justify-content: center;
}
  </style>
  